import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";

export const deleteProjectMember = async ({
  memberId,
  scope,
}: {
  memberId: string;
  scope: OrgProjectScope;
}): Promise<void> => {
  const client = getCoordinatorApi(scope);
  await client.delete(`/members/${memberId}`);
};
